import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { ReducerDataState } from 'shared/interface/globalInterface';
import { AdviserType } from 'components/DetailsPageBoilerplate/types';
import { useDispatch, useSelector } from 'react-redux';
import fetchDetails from 'store/details/actions/fetchDetails';
import { resetState } from 'store/details/actions';
import AdviserAdminProfileDetails from 'components/DetailsPageBoilerplate/AdviserAdminProfileDetails';
import { fetchSupportProfileDetails } from './utils/brokersFetcher';
import { updateProfile } from './utils/brokers';
import { Layouts, PageLayoutParams } from 'layouts/LayoutProvider';

const AdviserAdminProfilePage: React.FC<RouteComponentProps> & PageLayoutParams = () => {
  const fetchedDetails: ReducerDataState<AdviserType> = useSelector((state: any) => state.details);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchDetails(fetchSupportProfileDetails));

    return () => {
      dispatch(resetState());
    };
  }, [dispatch]);

  return (
    <AdviserAdminProfileDetails fetchedDetails={fetchedDetails} containerWidth={'xl'} onProfileUpdate={updateProfile} />
  );
};

AdviserAdminProfilePage.layout = Layouts.PROFILE;

export default AdviserAdminProfilePage;
